<template>
	<div class="content-wrapper table-responsive">
		<lead-profile-card 
			ref="leadProfileCard" 
    		:leadId="String(dataLead.id)"  
			v-if="dataLead?.id"
			:isNotTab="true"
		/>
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-10">
					<div class="card-header p-primary bg-transparent"></div>
					<app-overlay-loader v-if="preloader" />
					<form
						ref="form"
						:data-url="`/transaction/placement/sendPlacementResult/${id}`"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="card-body">
							<div class="col-md-12">
								
								<app-breadcrumb
									:page-title="''"
									v-if="dataLead"
									v-html="pageTitle"
									/>


								<hr
									style="
										border-top: 2px solid black;
										font-weight: bold;
									"
								/>
								<div class="row">
									<div class="col-lg-12">
										<div class="row">
																				
																					
											<label class="col-sm-12 mb-0"  v-if="showParentScheduleTrial">
												<b>Schedule</b>
											</label>
											<div class="col-md-3" v-if="showScheduleTrial">
												<div class="form-group">
													<label>Date</label>
													<app-input
														id="input_booked_date"
														v-model="placementResultForm.booked_date"
														type="date"
														placeholder=""
														:disabled="true"
														
													/>
												</div>
											</div>
											<div class="col-md-3" v-if="showTime">
												<div class="form-group">
													<label>Time</label>
													<app-input
														id="input_booked_time"
														v-model="placementResultForm.booked_time"
														type="time"
														placeholder=""
														:disabled="true"
													/>
												</div>
											</div>
											<div class="col-md-4" v-if="showExaminer">
												<div class="form-group">
													<label>Examiner</label>
													<app-input
														id="inputs_examiner_id"
														class="col-sm-9"
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="input_examiner_id"
														@input="setExaminerId"
														:fetch-url="`user-list?role_name=Teacher&per_page=50`"
														placeholder="Examiner"
														list-value-field="full_name"
														:disabled="!superAdminStatus"
													/>
										
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-3" v-if="showTrialClassName">
												<div class="form-group">
													<label>Trial Product Name</label>
													<app-input
														id="input_result_note"
														v-model="placementResultForm.trial_class_name"
														type="text"
														placeholder=""
														disabled
													/>
												</div>
											</div>
											<div class="col-md-3" v-if="showTrialResult">
												<div class="form-group">
													<label>Trial Package Name</label>
													<app-input
														id="input_result_note"
														v-model="placementResultForm.trial_result"
														type="text"
														placeholder=""
														disabled
													/>
												</div>
											</div>
											
										</div>
										
										<div class="row" v-if="showExaminerComment">
											<div class="col-md-6">
												<div class="form-group">
													<label>Examiner Comment</label>
													
													<app-input
														type="advance-search-select"
														:loaded-per-time="10"
														v-model="template_comment"
														@input="setTemplateCommentId"
														fetch-url="/master/template-comment"
														:placeholder="'Examiner Comment'"
														list-value-field="comment"
														:disabled="isView"
													/>
												</div>
											</div>
											
										</div>
										<div class="row">
											<div class="col-md-6">
												<div class="form-group">
													<label>Note</label>
													<app-input
														id="input_result_note"
														v-model="placementResultForm.note"
														type="text"
														placeholder=""
														:disabled="isView"
													/>
												</div>
											</div>
											
										</div>
										<div class="row" v-if="showScoreList">
											<div class="col-md-3">
												<div class="form-group">
													<label>Listening</label>
													
													<app-input
														type="search-select"
														:list="scoreList"
														name="listening_score"
														v-model="placementResultForm.listening_score"
														:isAnimatedDropdown="true"
														required
													/>
												</div>
											</div>
											<div class="col-md-3">
												<div class="form-group">
													<label>Speaking</label>
													
													<app-input
														type="search-select"
														:list="scoreList"
														name="speaking_score"
														v-model="placementResultForm.speaking_score"
														:isAnimatedDropdown="true"
														required
													/>
												</div>
											</div>
											
										</div>
									</div>
								</div>
							</div>


							<div class="col-md-12 mt-8">
								<lead-profile-tab-placement-result-test-table v-if="showPlacementResult"
									:placementId="id" :isView="isView"
								></lead-profile-tab-placement-result-test-table>
							</div>

							<div class="col-md-3" >
								
								<div class="row" style="margin-top: 39px;">
									<app-input
										id="inputs_no_class"
										:list-value-field="`No Class`"
										type="single-checkbox"
										class="col-md-12"
										v-model="placementResultForm.no_class"
									/>
								</div>
							</div>
							<div class="col-md-12 ">
								<lead-profile-tab-placement-recommend-class-table
									:placementId="id" :isView="isView"
								></lead-profile-tab-placement-recommend-class-table>
							</div>


							<div class="mt-2 mb-2 action-buttons" align="right">
								<button
									type="submit"
									class="btn btn-primary mr-2"
									@click.prevent="submitPlacementResult"
									:style="{ display: isView ? 'none' : '' }"
								>
									Submit
								</button>
							</div>
						</div>
					
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { PlacementResultFormMixin } from "./PlacementResultFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "PlacementResult",
	inject: ["eventHub"],
	mixins: [PlacementResultFormMixin, GlobalHelperMixin],
	data() {
		return {
			isView: false,
			preloader: false,
			sameAsAbove: false,
			id: null,
			showScoreList:false,
			showParentScheduleTrial : false,
			showScheduleTrial : false,
			showTrialClassName : false,
			showPlacementResult: false,
			showTrialResult : false,
			showTime : false,
			showExaminer : false,
			showExaminerComment : false,
			input_examiner_id: {},
			dataLead:{},
			titlePage:'',
			template_comment:{},
			superAdminStatus:0,
			placementResultForm: {
				template_comment_id:null,
				no_class:0,
				placement_id: null,
				placement_type: null,
				booked_date: null,
                trial_class_name: null,
                trial_result: null,
				booked_time: null,
				examiner_id: null,
				note: null,
				examiner_comment : null,
				listening_score : null,
				speaking_score : null,
			},
			scoreList: [
        				{ id: "Good", value: "Good" },
        				{ id: "Not good", value: "Not good" },
        				{ id: "Not Bad", value: "Not Bad" },
        				{ id: "Bad", value: "Bad" },
        				{ id: "None", value: "None" }
					],
		};
	},
	created() {
		let url = window.location.href;
		this.id = parseInt(url.split("/").slice(-1)[0].split("?")[0]);
		this.isView = url.includes("view");

		this.fetchData("created");
	},
	mounted() {
	},
	computed: {
		
		pageTitle() {
			const idLead =
			this.dataLead?.student_id ||
			this.dataLead?.lead_id_number ||
			this.dataLead?.clc_id_number ||
			'';

			return `
			<h4>
				${this.titlePage}
				${idLead ? ` - <a href='/transaction/profile-lead/${this.dataLead?.id}'
						class='text-primary'
						>${idLead}</a>` 
					: ''}
			</h4>
			`;
		}
	},
	methods: {
		async fetchData(from) {
			try {

				let placementResultTestResponse = await axios.get(`/transaction/placement/getHeaderResultPlacementTest/${this.id}`);

				let LeadResponse = await axios.get(`/transaction/getStudentByCLCIdNumber/`+placementResultTestResponse.data.clc_id_number);

				let placementParent = await axios.get(`/transaction/placement/${this.id}`);

				let userListResponse = await axios.get(`/get-users-by-session`);

				this.superAdminStatus = (userListResponse.data.roles[0]?.id === 1) ?? false;

				this.placementResultForm.no_class = placementParent.data.no_class;
				const resultHeader = placementResultTestResponse.data.result_header_placement_test;

				this.placementResultForm.placement_type = placementResultTestResponse.data.placement_type.id; 
				        
				this.dataLead = LeadResponse.data;
				if(placementResultTestResponse.data.placement_type.id == 1){
					
					this.placementResultForm.trial_class_name = placementParent.data.product_id.name;
					this.placementResultForm.trial_result = placementParent.data.package_name;

					this.titlePage = `Result Class Trial`;
					
					this.showScheduleTrial = true;
					this.showTrialClassName = true;
					this.showTrialResult = true;
					this.showTime = true;
					this.showExaminer = true;
					this.showExaminerComment = true;
					this.showParentScheduleTrial = true;
					this.template_comment = placementParent.data.template_comment ?? { id: null, comment: '' };
					this.placementResultForm.template_comment_id = placementParent.data.template_comment_id;

				}else if(placementResultTestResponse.data.placement_type.id == 2){
					
					this.titlePage = `Result Placement Test`;
					this.showScoreList = true;
					this.showScheduleTrial = true;
					this.showTime = true;
					this.showExaminer = true;
					this.showExaminerComment = true;
					this.showParentScheduleTrial = true;
					this.showPlacementResult = true;
					this.template_comment = placementParent.data.template_comment ?? { id: null, comment: '' };
					this.placementResultForm.template_comment_id = placementParent.data.template_comment_id;
					this.placementResultForm.listening_score = resultHeader ? resultHeader.listening_score : null;
					this.placementResultForm.speaking_score = resultHeader ? resultHeader.speaking_score : null;
					
				}else{
					
					this.titlePage = `Direct`;

				}
				if(placementResultTestResponse.data.assignee_id){
					this.input_examiner_id = placementResultTestResponse.data.assignee_id;
					this.placementResultForm.examiner_id = placementResultTestResponse.data.assignee_id.id;
				}else{
					this.input_examiner_id ={};
					this.placementResultForm.examiner_id = null;
				}

				this.placementResultForm.booked_date =
					placementResultTestResponse.data.booked_date ? placementResultTestResponse.data.booked_date : null;
					
				if (placementResultTestResponse.data.booked_time) {
					const time = placementResultTestResponse.data.booked_time;
					const [hour, minute] = time.split(':');
					this.placementResultForm.booked_time = `${hour}:${minute}`;
				} else {
					this.placementResultForm.booked_time = null;
				}

				this.placementResultForm.note =
					resultHeader ? resultHeader.note : null;

				this.placementResultForm.examiner_comment =
					resultHeader ? resultHeader.examiner_comment : null;
					
					
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		
		setExaminerId(data) {
			
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.placementResultForm, "examiner_id", data.id);
			}

			this.$set(this, "input_examiner_id", data);
		},
		
		setTemplateCommentId(data) {
			this.placementResultForm.template_comment_id = this.placementResultForm.template_comment_id;
			if (data && data.hasOwnProperty("id")) {
				this.template_comment = data;
				this.placementResultForm.template_comment_id = data.id;
			}
		},
		beforeSubmit() {
			this.preloader = true;
		},
		submitPlacementResult() {
			this.save(this.placementResultForm);
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			location.href=`/transaction/profile-lead/${this.dataLead?.id}`;
			this.clear();
		},
		afterFinalResponse() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterError(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
	watch: {
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}

.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.content-wrapper {
  margin-bottom: 200px; /* Adjust the margin value as needed */
  height: 90vh;
  padding-top: 0;
}
</style>
